<template>
  <m-card-item
    class="card-width-selector"
    :disabled="props.disabled"
    @click="showMenu = true"
  >
    <div>{{ $t('cardWidthSelector.title') }}</div>
    <template #right>
      <m-select
        :open="showMenu"
        :items="items"
        :value="value"
        hide-border
        hide-hover
        light
        no-padding
        @update:open="showMenu = $event"
        @update:value="updateValue"
      />
    </template>
  </m-card-item>
</template>

<script setup>
import { CARD_SIZE_LARGE, CARD_SIZE_MEDIUM, CARD_SIZE_SMALL, NONE } from '@/lib/constants';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps({
  value: {
    type: String,
    default: NONE,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const showMenu = ref(false);

const items = computed(() => [
  {
    text: t('cardWidthSelector.small'),
    value: CARD_SIZE_SMALL,
  },
  {
    text: t('cardWidthSelector.medium'),
    value: CARD_SIZE_MEDIUM,
  },
  {
    text: t('cardWidthSelector.large'),
    value: CARD_SIZE_LARGE,
  },
]);

const emit = defineEmits(['input', 'update:value']);
const updateValue = (val) => {
  emit('input', val);
  emit('update:value', val);
};
</script>
